import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip"
import Loader from '@/shared/components/Loader';

const ActionButton = ({ icon: Icon, tooltip, className, onClick, isLoading }) => {
  return (
    <TooltipProvider delayDuration={0} skipDelayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onClick={onClick}
            className={className}
            tabIndex={0}
            role="button"
            aria-label={tooltip}
          >
            {isLoading ? (
              <Loader variant='small'/>
            ) : (
              <Icon className="w-5 h-5" />
            )}
          </div>
        </TooltipTrigger>
        {tooltip && (
          <TooltipContent>
            <p>{tooltip}</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
};

export default ActionButton;
